<template>
  <section>
    <qx-custom-form @sub="sub" :noSubBtn="true" ref="baseForm" :formData="formData" />
  </section>
</template>

<script>
import {formatDateTimeSecond} from '@qx/utils';
import {mapState} from 'vuex';
import {saveSearch} from '@qx/utils/cache';

export default {
  props: {
    checkTypeOptions: {
      default: () => ([]),
    },
    accountNameOptions: {
      default: () => ([]),
    },
    originFormData: {
      default: () => ({}),
    },
    disabled: {
      default: false,
    },
  },
  data () {
    return {
      // hide:false,
      formData: {
        checkTypeOptions: this.checkTypeOptions,
        accountNameOptions: this.accountNameOptions,
        form: [
          {
            label: '类型',
            value: 'checkType',
            type: 'select',
            default: this.originFormData.checkType,
            placeholder: '请选择类型',
            disabled: this.disabled,
            onChange: () => {
              this.handleCheckTypeChange();
            },
          },
          {
            label: '主卡卡号',
            value: 'masterCardNo',
            default: this.originFormData.masterCardNo,
            type: 'input',
            placeholder: '请输入主卡卡号',
            valueKey: 'masterCardNo',
            disabled: this.disabled,
            hide: true,
          },
          {
            label: '冲抵金额',
            value: 'chargeAgainstMoney',
            type: 'input',
            default: this.originFormData.chargeAgainstMoney,
            placeholder: '请输入冲抵金额',
            disabled: this.disabled,
            hide: true,
            onInput: () => {
              const chargeAgainstMoney = this.$refs.baseForm.getVal('chargeAgainstMoney').replace(/[^\d.]/gi, '');
              if (chargeAgainstMoney.endsWith('.') || chargeAgainstMoney.endsWith('.0')) {
                this.$refs.baseForm.setVal('chargeAgainstMoney', chargeAgainstMoney);
              } else {
                this.$refs.baseForm.setVal('chargeAgainstMoney', Math.round(Number(chargeAgainstMoney) * 100) / 100);
              }

            },
          },
          {
            label: '余额',
            value: 'balance',
            type: 'input',
            default: this.originFormData.balance,
            placeholder: '',
            disabled: true,
            hide: true,
          },
          {
            label: '账户名称',
            value: 'accountName',
            type: 'select',
            default: this.originFormData.accountName,
            placeholder: '请选择账户名称',
            disabled: this.disabled,
            hide: false,
          },
          {
            label: '金额',
            value: 'checkFeeDouble',
            type: 'input',
            default: this.originFormData.checkFeeDouble,
            placeholder: '请输入金额',
            disabled: this.disabled,
            hide: false,
          },
          { // 交易时间
            label: '交易时间',
            value: 'transactionTime',
            type: 'date',
            default: this.originFormData.transactionTime || formatDateTimeSecond(new Date()),
            placeholder: '请输入交易时间',
            disabled: this.disabled,
            attr: {
              type: 'datetime',
              time: '00:00:00',
              format: 'yyyy-MM-dd HH:mm:ss',
              valueFormat: 'yyyy-MM-dd HH:mm:ss',
            },
          },
          {
            label: '对方户名',
            value: 'oppositeAccountName',
            default: this.originFormData.oppositeAccountName,
            type: 'el-autocomplete',
            placeholder: '请输入对方户名',
            valueKey: 'oppsiteAcctName',
            disabled: this.disabled,
            hide: false,
            querySearchAsync: (queryString, cb) => {
              // cb 返回的是检索出来匹配的数组
              let searchData = [];
              let filterData = [];
              const userId = this.userInfo.staffTFInfo.userId;
              if (queryString && queryString.length) {
                searchData = JSON.parse(localStorage.getItem(`${userId}_opAcctName`));
                searchData.filter((item) => {
                  if (item.includes(queryString)) {
                    filterData.push({
                      oppsiteAcctName: item,
                    });
                  }
                });
                // this.onSearch(true);
                cb(filterData);
              } else {
                cb(filterData);
              }
            },
          },
          {
            label: '对方账号',
            value: 'oppositeAccountNumber',
            default: this.originFormData.oppositeAccountNumber,
            type: 'el-autocomplete',
            placeholder: '请输入对方账户',
            valueKey: 'oppsiteAcctNum',
            disabled: this.disabled,
            hide: false,
            querySearchAsync: (queryString, cb) => {
              // cb 返回的是检索出来匹配的数组
              let searchData = [];
              let filterData = [];
              const userId = this.userInfo.staffTFInfo.userId;
              if (queryString && queryString.length) {

                searchData = JSON.parse(localStorage.getItem(`${userId}_opAcctNum`));
                searchData.length > 0 && searchData.filter((item) => {
                  if (item.includes(queryString)) {
                    filterData.push({
                      oppsiteAcctNum: item,
                    });
                  }
                });
                // this.onSearch(true);
                cb(filterData);
              } else {
                cb(filterData);
              }
            },
          },
          {
            label: '说明',
            value: 'checkDesc',
            type: 'input',
            default: this.originFormData.checkDesc,
            placeholder: '请输入说明',
            disabled: this.disabled,
          },
          {
            label: '附件',
            value: 'file',
            type: 'img',
            accept: 'image/*',
            attr: {
              limit: 1,
            },
            disabled: this.disabled,
            default: this.originFormData.fileIds ? [{
              id: this.originFormData.fileIds,
              url: this.originFormData.fileUrls,
            }] : [],
          },
        ],
        rules: { // 表单验证规则
          checkType: [ // 类型
            { required: true, message: '请选择类型', trigger: 'blur' },
          ],
          checkFeeDouble: [ // 金额
            { required: true, message: '请输入金额', trigger: 'blur' },
          ],
          transactionTime: [ // 交易时间
            { required: false, message: '请选择交易时间', trigger: 'blur' },
          ],
          oppositeAccountName: [ // 对方户名
            { required: false, message: '请输入对方户名', trigger: 'blur' },
          ],
          oppositeAccountNumber: [ // 对方账号
            { required: false, message: '请输入对方账号', trigger: 'blur' },
          ],
          masterCardNo: [ // 主卡卡号
            { required: false, message: '请输入主卡卡号', trigger: 'blur' },
          ],
          chargeAgainstMoney: [ // 抵充金额
            { required: false, message: '请输入抵充金额', trigger: 'blur' },
          ],
        },
      },
    };
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo, // 用户信息
    }),
  },
  methods: {
    handleCheckTypeChange () {
      let Field = false;
      const checkType = this.$refs.baseForm.getVal('checkType') || this.originFormData.checkType;
      console.log('checkType', checkType);
      if (`${checkType}` === '7') {
        this.setFormAttrVal({
          form: this.formData,
          attr: 'hide',
          value: false,
          names: ['masterCardNo', 'chargeAgainstMoney'],
        // names: ['masterCardNo', 'chargeAgainstMoney','balance'],
        });

        this.setFormAttrVal({
          form: this.formData,
          attr: 'hide',
          value: true,
          names: ['accountName', 'checkFeeDouble', 'oppositeAccountName', 'oppositeAccountNumber'],
        });
        this.formData.rules.masterCardNo[0].required = true;
        this.formData.rules.chargeAgainstMoney[0].required = true;
      } else {
        this.setFormAttrVal({
          form: this.formData,
          attr: 'hide',
          value: true,
          names: ['masterCardNo', 'chargeAgainstMoney', 'balance'],
        });

        this.setFormAttrVal({
          form: this.formData,
          attr: 'hide',
          value: false,
          names: ['accountName', 'checkFeeDouble', 'oppositeAccountName', 'oppositeAccountNumber'],
        });
        this.formData.rules.masterCardNo[0].required = false;
        this.formData.rules.chargeAgainstMoney[0].required = false;
      }
      if (`${checkType}` === '1' || `${checkType}` === '2' || `${checkType}` === '3') {
        // 当类型选择为现汇核销、承兑核销、冲抵核销时，为必填项
        Field = true;

      }
      this.formData.rules.transactionTime[0].required = Field;
      this.formData.rules.oppositeAccountName[0].required = Field;
      this.formData.rules.oppositeAccountNumber[0].required = Field;
    },
    async sub () {
      const formData = await this.$refs.baseForm.sub();
      let accountArr = [];
      this.accountNameOptions.map((item) => {
        if (formData.accountName && item.bankCardNo === formData.accountName) {
          accountArr = item;
        }
      });

      if (formData) {
        if (formData.file && formData.file[0]) {
          formData.fileIds = formData.file[0].id;
          formData.fileUrls = formData.file[0].url;
        }
        formData.accountName = accountArr.accountName || this.originFormData.accountName,
        formData.accountType = Number(accountArr.accountType) || Number(this.originFormData.accountType),
        formData.accountNo = accountArr.bankCardNo || this.originFormData.accountNo,
        formData.balance = accountArr.balance,
        formData.checkId = this.originFormData.checkId;
      }
      return formData;
    },

  },
  created () {
    const userId = this.userInfo.staffTFInfo.userId;
    saveSearch(`${userId}_opAcctNum`, ''); // 进入页面默认存一条对方账户搜索记录为空，解决第一次搜索对方账户时转圈问题
    saveSearch(`${userId}_opAcctName`, ''); // 进入页面默认存一条对方户名搜索记录为空，解决第一次搜索对方账户时转圈问题
    let Field = false;
    if (this.originFormData.checkType === '7') {
      // this.$nextTick(()=>{
      //   this.hide = false
      // })
      this.setFormAttrVal({
        form: this.formData,
        attr: 'hide',
        value: false,
        names: ['masterCardNo', 'chargeAgainstMoney'],
        // names: ['masterCardNo', 'chargeAgainstMoney','balance'],
      });

      this.setFormAttrVal({
        form: this.formData,
        attr: 'hide',
        value: true,
        names: ['accountName', 'checkFeeDouble', 'oppositeAccountName', 'oppositeAccountNumber'],
      });
      this.formData.rules.masterCardNo[0].required = true;
      this.formData.rules.chargeAgainstMoney[0].required = true;
    } else {
      this.setFormAttrVal({
        form: this.formData,
        attr: 'hide',
        value: true,
        names: ['masterCardNo', 'chargeAgainstMoney', 'balance'],
      });

      this.setFormAttrVal({
        form: this.formData,
        attr: 'hide',
        value: false,
        names: ['accountName', 'checkFeeDouble', 'oppositeAccountName', 'oppositeAccountNumber'],
      });
      this.formData.rules.masterCardNo[0].required = false;
      this.formData.rules.chargeAgainstMoney[0].required = false;
    }
    if ((this.originFormData.checkType !== '4' || this.originFormData.checkType !== '5') && !this._props.disabled) {
      Field = true;
    }
    this.formData.rules.transactionTime[0].required = Field;
    this.formData.rules.oppositeAccountName[0].required = Field;
    this.formData.rules.oppositeAccountNumber[0].required = Field;
  },
};
</script>

<style>
</style>
